import Helpers from "../../../Javascript/Helpers";

const _ = {
    onMediaQueriesChange () {
        const disableMenuCheckboxTrigger = (matches) => {
            this.checkboxMenuTriggers.forEach((el) => {
                el.disabled = matches;
            });
            if (matches) {
                this.contactsElement.classList.remove('hide');
            } else {
                this.contactsElement.classList.add('hide');
            }
        };

        if (matchMedia) {
            /**
             * @type MediaQueryList
             */
            const mediaQueries = window.matchMedia("(min-width: 769px)");
            mediaQueries.addListener((mq) => {
                disableMenuCheckboxTrigger(mq.matches);
            });

            // on load
            disableMenuCheckboxTrigger(mediaQueries.matches);
        }
    },
    onLoad () {
        const activeMenu = document.querySelector('.M-Navigation__Main__Level1__Item.active input');

        if (activeMenu) {
            activeMenu.checked = true;
        }
    }
};

/**
 * singleton ... fake
 */
class Navigation {

    constructor (selector) {
        this.menu = document.querySelector(selector);
        this.bgOverlay = document.querySelector('.O-Navigation__BgOverlay');
        this.toggleBar = document.querySelector('.NavigationToggle');
        this.toggleButtons = document.querySelectorAll('.NavigationToggle__Button');
        this.checkboxMenuTriggers = document.querySelectorAll('input[id^=navMobileTab]');
        this.contactsElement = document.querySelector('.O-Navigation__Contacts');

        _.state = {isOpen: false};

        _.onMediaQueriesChange.call(this);
        _.onLoad();
    }

    init () {
        const toggleMenu = (e) => {
            e.preventDefault();
            this.menu.classList.contains('Navigation--active') ? this.close() : this.open();
        },
        radioChange = (e) => {
            e.preventDefault();
            if (e.target.id === 'navMobileTab4') {
                this.contactsElement.classList.remove('hide');
                this.contactsElement.classList.add('show-delay-400');
            } else {
                this.contactsElement.classList.remove('show-delay-400');
                this.contactsElement.classList.add('hide');
            }
        };

        this.toggleButtons.forEach((element) => {
            element.addEventListener('click', toggleMenu, false);
        });

        this.checkboxMenuTriggers.forEach((element) => {
            element.addEventListener('change', radioChange, false);
        });

        this.bgOverlay.addEventListener('click', (e) => {
            this.close();
        });
    }

    close () {
        if (this.menu.classList.contains('Navigation--active')) {
            this.bgOverlay.style.display = 'none';
            Helpers.triggerCustom(document, 'navigationToggle:close');
            this.toggleButtons[0].classList.add('hide');
            this.menu.classList.remove('Navigation--active');
            setTimeout(() => {this.toggleButtons[1].classList.remove('hide');}, 280);
        }
    }

    open () {
        if (!this.menu.classList.contains('Navigation--active')) {
            this.toggleButtons[1].classList.add('hide');
            this.menu.classList.add('Navigation--active');
            setTimeout(() => {this.toggleButtons[0].classList.remove('hide');}, 300);
            Helpers.triggerCustom(document, 'navigationToggle:open');
            this.bgOverlay.style.display = 'block';
        }
    }

    static getState () {
        return _.state;
    }

    /**
     * @param position
     * @see relation in frontend.js and call from ScrollMonitor
     */
    onScroll (position) {
        (position > 1) ? this.toggleBar.classList.add('NavigationToggle--scroll') : this.toggleBar.classList.remove('NavigationToggle--scroll');
    }
}

export default Navigation;
